import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { CdkDragHandle } from "@angular/cdk/drag-drop";
import { LgIconComponent } from "../../lg-icon/lg-icon.component";
import { LgSimpleOverflowTooltipDirective } from "../../../lg-tooltip/lg-simple-overflow-tooltip.directive";

import type { OrderedItemId, OrderedItem } from "../lg-ordered-item-selector.model";

@Component({
    selector: "lg-ordered-item",
    templateUrl: "./lg-ordered-item.component.html",
    styleUrls: ["./lg-ordered-item.component.scss"],
    imports: [LgIconComponent, CdkDragHandle, LgSimpleOverflowTooltipDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        type: "button",
        tabindex: "0",
        "[class.ordered-item--disabled]": "isDisabled()",
        "(click)": "_onToggleMenu($event)",
        "(keydown.enter)": "_onToggleMenu($event)",
        "(keydown.space)": "_onToggleMenu($event)"
    }
})
export class LgOrderedItemComponent {
    readonly menuItem = input<OrderedItem | undefined>();
    readonly selectedItem = input.required<OrderedItemId>(); // used as fallback for display in case definition of the selected item is missing
    readonly itemPosition = input.required<number>();
    readonly isDisabled = input<boolean>(false);

    readonly toggleMenu = output<OrderedItemId>();
    readonly removeItem = output<OrderedItemId>();

    protected _onToggleMenu(event: Event): void {
        if (this.isDisabled()) {
            return;
        }

        event.preventDefault();
        this.toggleMenu.emit(this.selectedItem());
    }

    protected _onRemoveItem(event: Event): void {
        if (this.isDisabled()) {
            return;
        }

        event.stopPropagation();
        this.removeItem.emit(this.selectedItem());
    }
}
